<template>
  <div style="width: 420px;margin: 0 auto">
    <div style="margin: 20px;"></div>
    <el-form :model="bannerForm" status-icon ref="bannerForm" label-width="100px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="bannerForm.bannerTitle"></el-input>
      </el-form-item>
      <el-form-item label="类名" prop="category" align="left">
        <el-select
          v-model="bannerForm.index"
          placeholder="请选择当前banner所属分类.."
        >
          <el-option
            v-for="item in BannerOptions"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="pc图片" prop="banner_pc" align="left">
        <el-upload
          class="upload-demo"
          ref="pcUpload"
          action="string"
          accept="image/jpeg, image/png, image/jpg"
          list-type="picture-card"
          :before-upload="onBeforeUploadImage"
          :http-request="UploadPcImage"
          :on-preview="handlePictureCardPcPreview"
          :on-remove="handleRemove"
          :on-change="filePcChange"
          :file-list="pcFileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件，且不超过1M</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="iphone图片" prop="banner_iphone" align="left">
        <el-upload
          class="upload-demo"
          ref="iphoneUpload"
          action="string"
          accept="image/jpeg, image/png, image/jpg"
          list-type="picture-card"
          :before-upload="onBeforeUploadImage"
          :http-request="UploadIphoneImage"
          :on-preview="handlePictureCardIphonePreview"
          :on-remove="handleRemove"
          :on-change="fileIphoneChange"
          :file-list="iphoneFileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/jpeg/png文件，且不超过1M</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="resetForm('bannerForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogPcImageVisible">
      <img width="100%" :src="bannerForm.bannerPc" alt />
    </el-dialog>
    <el-dialog :visible.sync="dialogIphoneImageVisible">
      <img width="100%" :src="bannerForm.bannerIphone" alt />
    </el-dialog>
  </div>
</template>

<script>
import {
    putRequest,
    getRequest,
    postRequest,
    uploadFileRequest
} from "@/utils/api";
export default {
  name: "updateBanner",
  data() {
    return {
      pcFileList: [],
      iphoneFileList: [],
      dialogPcImageVisible: false,
      dialogIphoneImageVisible: false,
      bannerForm: {
        bannerTitle: "",
        bannerPc: "",
        bannerIphone: "",
        index: ""
      },
      BannerOptions: [
        { id: 1, label: "首页", value: "index" },
        { id: 2, label: "产品", value: "product" },
        { id: 3, label: "资讯", value: "news" }
      ]
    };
  },
  mounted() {},
  methods: {
    onBeforeUploadImage(file) {
      const isIMAGE = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
      }
      if (!isLt1M) {
        this.$message.error("上传文件大小不能超过 1MB!");
      }
      return isIMAGE && isLt1M;
    },
    UploadPcImage(param) {
      const formData = new FormData();
      formData.append("image", param.file);
      this.bannerForm.bannerPc = formData;
    },
    UploadIphoneImage(param) {
      const formData = new FormData();
      formData.append("image", param.file);
      this.bannerForm.bannerIphone = formData;
    },
    filePcChange(file) {
        this.$refs.pcUpload.clearFiles(); //清除文件对象
        this.pcFileList = [{ name: file.name, url: file.url }]; // 重新手动赋值pcFileList， 免得自定义上传成功了, 而pcFileList并没有动态改变， 这样每次都是上传一个对象
    },
    fileIphoneChange(file) {
        this.$refs.iphoneUpload.clearFiles(); //清除文件对象
        this.iphoneFileList = [{ name: file.name, url: file.url }]; // 重新手动赋值pcFileList， 免得自定义上传成功了, 而pcFileList并没有动态改变， 这样每次都是上传一个对象
    },
    handlePictureCardPcPreview(file) {
        this.bannerForm.bannerPc = file.url;
        this.dialogPcImageVisible = true;
    },
    handlePictureCardIphonePreview() {
        this.bannerForm.bannerIphone = file.url;
        this.dialogIphoneImageVisible = true;
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },
    handleRemove() {},
    submitForm() {
        const {bannerTitle,bannerPc,bannerIphone,index} = this.bannerForm;
        if (bannerTitle === "" || bannerTitle === null) {
            return this.failedInfo("banner标题不得为空");
        }
        if (index === "" || index === null) {
            return this.failedInfo("请选择banner分类");
        }
        if (bannerPc === "" || bannerPc === null) {
            return this.failedInfo("请上传PCbanner图片");
        } else {
            this.info("上传中......")
            uploadFileRequest('/banner/uploadimg', bannerPc).then(res => {
                const {code, message, data:pcImage} = res.data;
                if(code === 200) {
                    if(bannerIphone !== '' || bannerIphone !== null) {
                        uploadFileRequest('/banner/uploadimg', bannerIphone).then(ress => {
                            const {code, message, data:iphoneImage} = ress.data;
                            if(code === 200) {
                                postRequest('/banner/add',{
                                    bannerTitle,
                                    bannerPc: pcImage,
                                    bannerIphone: iphoneImage,
                                    banerIndex:index
                                }).then(response => {
                                    const {code,message} = response.data;
                                    if(code === 200) {
                                        this.successInfo("上传成功");
                                    }
                                }).catch((err) => {
                                    this.failedInfo("请检查网络是否错误");
                                })
                            }
                        })
                    }
                } else {
                    this.failedInfo("上传错误,请重新上传")
                }
            }).catch((err) => {
                this.failedInfo("请检查网络是否错误");
            })
        }

    },
    info(info) {
        this.$message({ type: "info", message: info });
    },
    successInfo(info) {
        this.$message({ type: "success", message: info });
    },
    failedInfo(info) {
        this.$message({ type: "error", message: info });
    }
  }
};
</script>

<style scope>
</style>


// WEBPACK FOOTER //
// src/pages/banner/changeBanner.vue